export const container = {
  hidden: { scaleX: 0, opacity: 0 },
  show: {
    scaleX: 1,
    opacity: 1,
    transition: { delayChildren: 1, staggerChildren: 0.5 },
  },
};
